import { format, formatDistanceToNow, formatISO9075 } from "date-fns";
import { utcToZonedTime, zonedTimeToUtc } from "date-fns-tz";

export function dateToUTC(str) {
  return utcToZonedTime(str, "UTC");
}

export function dateFromUTC(str) {
  return zonedTimeToUtc(str, "UTC");
}

export function prepareDate(date) {
  if (!date) return undefined;
  return formatISO9075(date, { representation: "date" });
}

export function prepareDateUTC(date) {
  if (!date) return undefined;
  return formatISO9075(dateToUTC(date), { representation: "date" });
}

export function prepareDateTimeUTC(date) {
  if (!date) return undefined;
  return formatISO9075(dateToUTC(date));
}

export function formatTime(str) {
  if (typeof str === "string") str = dateFromUTC(str);
  return format(str, "HH:mm");
}
export function formatDate(str) {
  if (typeof str === "string") str = dateFromUTC(str);
  return format(str, "yyyy-MM-dd");
}

export function formatDateTime(str) {
  if (typeof str === "string") str = dateFromUTC(str);
  return format(str, "dd/MM/yyyy HH:mm:ss");
}

export function formatDateTimeNow(str, locale) {
  if (typeof str === "string") str = dateFromUTC(str);
  return formatDistanceToNow(str, { addSuffix: true, locale });
}
